import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend' // fallback xhr load
import { camelCase, capitalize, lowerCase, upperCase } from 'lodash'
import { initReactI18next } from 'react-i18next'
import moment from 'moment'

import 'moment/locale/de'
import 'moment/locale/el'
import 'moment/locale/en-gb'
import 'moment/locale/es'
import 'moment/locale/et'
import 'moment/locale/fr'
import 'moment/locale/it'
import 'moment/locale/nl'
import 'moment/locale/pt'
import 'moment/locale/cs'
import 'moment/locale/tr'
import 'moment/locale/ru'
import 'moment/locale/pl'

import { postToApi, injectLanguageInApi } from '../../services/apiService'
import { currencyFrom, currencySymbol } from '../currency'
import configurations from './configurations'

const USED_LANGUAGES = ['en-gb', 'fr', 'de', 'nl', 'it', 'es', 'pt', 'cs', 'et', 'el', 'tr', 'ru', 'pl']
const DEFAULT_LANGUAGE = 'en-gb'

const languageDetectionOption = {
  // order and from where user language should be detected
  order: ['querystring', 'navigator'],

  // keys or params to lookup language from
  lookupQuerystring: 'lng'
}

console.log(
  '**************************** init i18nnext with backend ' +
    configurations.UFO_SERVER_PUBLIC_API_URL
)
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    detection: languageDetectionOption,
    fallbackLng: 'en',
    debug: false,
    ns: [
      'common',
      'bookingCommon',
      'bookingBook',
      'bookingPersonalize',
      'bookingPay',
      'bookingConfirmation',
      'waitinglist',
      'connect'
    ],
    interpolation: {
      format: function(value: any, format: any, lng: any) {
        if (typeof value === 'string' && format === 'upperCase') {
          return upperCase(value)
        }

        if (typeof value === 'string' && format === 'lowerCase') {
          return lowerCase(value)
        }

        if (typeof value === 'string' && format === 'camelCase') {
          return camelCase(value)
        }

        if (typeof value === 'string' && format === 'capitalize') {
          return capitalize(value)
        }

        if (typeof value === 'string' && format === 'symbol') {
          try {
            return currencySymbol(currencyFrom(value))
          } catch (error) {
            return value
          }
        }

        if (typeof value === 'object' && value instanceof Date) {
          return moment(value).format(format)
        }

        if (typeof value === 'object' && moment.isMoment(value)) {
          return value.format(format)
        }

        return value
      },
      escapeValue: false,
      defaultVariables: { platform: configurations.UFO_APP_PLATFORM_NAME }
    },
    react: {
      wait: true,
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      useSuspense: true
    },
    saveMissing: true,
    backend: {
      // xhr load path for my own fallback
      loadPath: `${configurations.UFO_SERVER_PUBLIC_API_URL}v2/i18n/booking-app/{{lng}}/{{ns}}`,
      addPath: null,
      allowMultiLoading: false
    }
  })

i18n.on('languageChanged', function(lng) {
  if (lng && lng.length >= 2) {
    const currentLanguage = lng.substring(0, 2)
    const language = USED_LANGUAGES.includes(currentLanguage)
      ? currentLanguage
      : DEFAULT_LANGUAGE
    console.debug('I18n.initialized', language)
    console.warn('Translations configure moment language to [%s]', language)
    moment.locale(language)
    injectLanguageInApi(language)
  }
})

i18n.on('missingKey', function(
  lngs: string[],
  namespace: string,
  key: string,
  res: any
) {
  postToApi('v2/i18n/booking-app/' + namespace + '/' + key, {})
    .then()
    .catch()
})

export default i18n
